import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Button, Card, Form, Table } from 'react-bootstrap';
import { MdBrightness5 } from "react-icons/md";
import Seguimiento from './seguimiento';
import AddModProceso from './add-mod-proceso';
import { serviceGetCasoImplicado, serviceGetProcesosJudiciales } from '../../../../../api/api-antecendentes-legales';
import { LoadingComponent } from 'recupero-comunes';


const Procesos = ({ cfg_form, handleCloseAntecedentes }) => {
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer);
    const { llaves } = data_recepciona;
    const [loading, setLoading] = useState(false);
    const [showAddMod, setShowAddMod] = useState(false);
    const [showSeguimiento, setShowSeguimiento] = useState(false);
    const [procesos, setProcesos] = useState([]);
    const [cancelSubmit, setCancelSubmit] = useState("");
    const [proceso, setProceso] = useState(null);
    const [procesoSeguimiento, setProcesoSeguimiento] = useState(null);
    const [posSelected, setPosSelected] = useState(-1);
    const [defaultChecked, setDefaultChecked] = useState(false);

    const [fechaSinistro, setFechaSinistro] = useState("");

    useEffect(() => {
        initialData();
    }, [])

    useEffect(() => {
        if (cancelSubmit === "submit") { getProcesosJudiciales(); setCancelSubmit("")};
    }, [cancelSubmit])

    useEffect(() => {
        if (posSelected !== -1) setProcesoSeguimiento(procesos[posSelected])
    }, [procesos])

    const initialData = async () => {
        setLoading(true);

        await getCasoImplicado();
        await getProcesosJudiciales();
    }

    const getCasoImplicado = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: 0 })).toString('base64');
        const response = await serviceGetCasoImplicado(query);

        setFechaSinistro(response && response[0].FechaSiniestroFormat);
    }

    const getProcesosJudiciales = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso })).toString('base64');
        const response = await serviceGetProcesosJudiciales(query);

        setLoading(false);
        setProcesos(response);

        if (response && response.length == 1) {
            handleSegimiento(response[0], 0);
            setDefaultChecked(true);
        } else {
            setShowSeguimiento(false);
        }
    }

    const handleShowAddMod = (selected) => {
        setProceso(selected);
        setShowAddMod(true);
    }

    const handleSegimiento = (selected, pos) => {
        setShowSeguimiento(true);
        setProcesoSeguimiento(selected);
        setPosSelected(pos);
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                <Card.Header style={{ display: 'flex', justifyContent: 'right' }}>
                    <Button className='w-auto' variant='danger' onClick={() => handleShowAddMod(null)}>
                        {cfg_form["modalantecedentesjudicialesdefensa-btn-crearproces"]}
                    </Button>
                </Card.Header>

                <Card.Body className="customCard">
                    <Table striped className="customTable">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Competencia</th>
                                <th>Region/Corte</th>
                                <th>Juzgado/Tribunal</th>
                                <th>Nro. Causa/Rol</th>
                                <th>Fecha Ing. Causa</th>
                                <th>Estado</th>
                                <th style={{ width: '30px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {procesos.map((proceso, index) => (
                                <tr key={index}>
                                    {procesos.length == 1 &&
                                        <td >
                                            <Form.Check type="radio" checked={defaultChecked} name="group1" id={`radio-${index}`} onChange={() => handleSegimiento(proceso, index)} />
                                        </td>
                                    }
                                    {procesos.length > 1 &&
                                        <td >
                                            <Form.Check type="radio" name="group1" id={`radio-${index}`} onChange={() => handleSegimiento(proceso, index)} />
                                        </td>
                                    }
                                    <td>{proceso.competencia}</td>
                                    <td>{proceso.corte}</td>
                                    <td>{proceso.tribunal}</td>
                                    <td>{proceso.rolCausa}</td>
                                    <td>{proceso.fecIngresaCausaFormat}</td>
                                    <td>{proceso.glosaEstado}</td>
                                    <td>
                                        <Button variant='opciones me-md-2' size='sm' onClick={() => handleShowAddMod(proceso)}>
                                            <MdBrightness5 size={20} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {procesos.length === 0 &&
                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                    }
                </Card.Body>

                <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                    <Button className='w-auto' variant='outline-info' onClick={handleCloseAntecedentes}>
                        {cfg_form["modalantecedentesjudicialesdefensa-btn-volver"]}
                    </Button>
                </Card.Footer>
            </Card>

            {showSeguimiento && <Seguimiento
                cfg_form={cfg_form}
                proceso={procesoSeguimiento}
                fechaSinistro={fechaSinistro}
                setProcesos={setProcesos}
            />}

            <AddModProceso
                showAddMod={showAddMod}
                setShowAddMod={setShowAddMod}
                setCancelSubmit={setCancelSubmit}
                proceso={proceso}
                fechaSinistro={fechaSinistro}
            />

            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Procesos;